
import { getApi, postApi } from "../api/base";
import { uploadFileChunkIntermediary } from "../services/fileUploadServicer";


export const uploadFileHandler = async (file: File, filePath: string): Promise<void> => {
    console.log(file, filePath, "📁 Uploading to path");
    const chunkSize = 5 * 1024 * 1024; // 5MB
    const totalChunks = Math.ceil(file.size / chunkSize);
    const eTags: string[] = Array.from({ length: totalChunks }, () => "");
    let uploadFileId: string | null = null;
    const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
        let binary = "";
        for (let i = 0; i < uint8Array.length; i++) {
            binary += String.fromCharCode(uint8Array[i]);
        }
        return btoa(binary);
    };
    try {
        const initPayload = {
            fileName: `public/${filePath}`,
            chunkIndex: -1,
            uploadFileId: "",
            uploadedAllChunks: false,
            eTags: [],
            bytesRead: 0,
        };
        const initResponse = await uploadFileChunkIntermediary(initPayload);
        uploadFileId = initResponse;
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
            const start = chunkIndex * chunkSize;
            const end = Math.min(file.size, start + chunkSize);
            const fileChunk = file.slice(start, end);
            const arrayBuffer = await fileChunk.arrayBuffer();
            const base64String = uint8ArrayToBase64(new Uint8Array(arrayBuffer));
            const chunkPayload = {
                fileName: `public/${filePath}`,
                chunkIndex: chunkIndex,
                fileContents: base64String,
                uploadFileId: uploadFileId,
                uploadedAllChunks: false,
                bytesRead: end,
                eTags,
            };
            try {
                const response = await uploadFileChunkIntermediary(chunkPayload);
                console.log("💬 Response from chunk upload:", response);
                eTags[chunkIndex] = response;
                console.log(`✅ Chunk ${chunkIndex} uploaded`);
            } catch (error) {
                console.error(` Error uploading chunk ${chunkIndex}:`, error);
                return;
            }
        }
        const finalizePayload = {
            fileName: `public/${filePath}`,
            chunkIndex: -1,
            uploadFileId: uploadFileId,
            uploadedAllChunks: true,
            eTags,
            bytesRead: file.size,
        };
        await uploadFileChunkIntermediary(finalizePayload);
        console.log(" Upload completed successfully!");
    } catch (error: any) {
        console.error(" Upload failed:", error);
    }
};

export const GetPreSignedUrlFile = async (filePath: string): Promise<string> => {
    try {
        const encodedPath = encodeURIComponent(`public/${filePath}`);
        const response = await getApi(`api/Hoa/Hoa/GetPreSignedUrl?fileName=${encodedPath}`);
        const url = response;
        return url;
    } catch (error: any) {
        console.error("Error during file download:", error);
        throw new Error(error?.message || "File download failed.");
    }
};

export const CreateFolder = async (filePath: string): Promise<string> => {
    try {

        const response = await getApi(`api/Hoa/Hoa/CreateFolderAsync?folderName=public/${filePath}`)
        const res = await response;
        return res;
    } catch (error: any) {
        console.error("Error during file download:", error);
        throw new Error(error?.message || "File download failed.");
    }
};
